import type { Text } from '@kkf/design'
export interface ContactInfo {
  icon: string
  title: Text
  /**
   * What the row says.
   *
   * `Text | string`: the inbox is an address and is printed as written, and the other two
   * are sentences about what is not known yet.
   */
  value: Text | string
  /** Present only where there is something to open. Omit it for a fact. */
  href?: string
}

/**
 * How to reach the Foundation.
 *
 * **The email is the only working channel, so it is first.** The template shipped
 * `+44 204 577 0077`, `fandi@gmail.com` and `Washington Ave, NY` here, all three of which
 * read as real. The address and the telephone number still do not exist — what is known is
 * that the Foundation is in Ulaanbaatar — so they say so rather than being filled in with
 * something plausible. A wrong number on a contact page is worse than a missing one: the
 * missing one sends you to the email, and the wrong one sends you nowhere twice.
 *
 * When the street address and a telephone number arrive, add them here, add
 * `streetAddress`, `telephone` and `geo` to `data/seo.ts`'s `organization` descriptor, and
 * work through `docs/04-operations/seo-and-marketing.md` § Local search.
 */
export const CONTACT_INFOS: ContactInfo[] = [
  {
    icon: 'comment',
    title: { en: 'Email address', mn: 'И-мэйл хаяг' },
    value: 'foundation@kkfmongolia.com',
    href: 'mailto:foundation@kkfmongolia.com',
  },
  { icon: 'phone-call', title: { en: 'Phone number', mn: 'Утасны дугаар' }, value: { en: 'To be confirmed — please email us', mn: 'Тодруулна — бидэн рүү и-мэйл бичнэ үү' } },
  {
    icon: 'location',
    title: { en: 'Where we are', mn: 'Бид хаана байдаг вэ' },
    value: { en: 'Ulaanbaatar, Mongolia — street address to be confirmed', mn: 'Улаанбаатар, Монгол Улс — гудамжны хаягийг тодруулна' },
  },
]

/*
 * `CONTACT_MAP_SRC` was here and was removed on 2026-09-03 along with the map on
 * `/contact`. It was the template's embed, centred on **Rangpur Zoo, Bangladesh**, and a
 * map on a contact page is read as "this is where we are". There is no address to centre a
 * correct one on yet.
 *
 * A missing map is not a claim. A wrong one is, and this page is indexed. Put it back —
 * here and in `pages/ContactPage.tsx` — the day there is a street address, and use the
 * resort's coordinates rather than a city-level pin, which would be the same mistake at a
 * smaller scale.
 */
